export default __webpack_public_path__ + "static/cover_1920-d485267c72baddd8cef798815aa8023e.jpg";